import React from "react";
import { Box, Typography, Grid, Card, CardMedia } from "@mui/material";

const VisionMissionSection = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                padding: 4,
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "100vh",
            }}
        >
            {/* Overlay */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(246, 242, 242, 0.6)", // Overlay for better visibility
                    zIndex: 1,
                }}
            ></Box>

            {/* Vision Section */}
            <Grid
                container
                spacing={4}
                sx={{ alignItems: "center", zIndex: 2 }}
            >
                {/* Text Content */}
                <Grid item xs={12} md={6}>
                    <Typography
                        variant="h4"
                        data-aos="fade-up"
                        sx={{
                            fontWeight: "bold",
                            marginBottom: 2,
                            color: "black",
                            fontFamily: '"Montserrat", sans-serif',
                        }}
                    >
                        Vision
                    </Typography>
                    <Typography
                        data-aos="fade-up"
                        variant="body1"
                        sx={{ color: "black", lineHeight: 1.8 }}
                    >
                        We envision expanding our company worldwide with more services and
                        products offered with the intention of creating long-term clients
                        and relationships that will merit both parties. We intend to expand
                        the array of products that we deliver to your doorsteps. Keeping
                        our promises, we hope to become one of the largest distributors and
                        a trading platform worldwide in the upcoming years.
                    </Typography>
                </Grid>
                {/* Image */}
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "18px",
                            overflow: "hidden",
                            boxShadow: 3,
                        }}
                        data-aos="fade-up"
                    >
                        <CardMedia
                            component="img"
                            image="https://i.postimg.cc/Qtw1k6S8/smm10-45.webp"
                            alt="Vision"
                            sx={{
                                width: "100%",
                                height: "300px",
                                objectFit: "cover",
                            }}
                        />
                    </Card>
                </Grid>
            </Grid>

            {/* Mission Section */}
            <Grid
                container
                spacing={4}
                sx={{ alignItems: "center", zIndex: 2 }}
            >
                {/* Image */}
                <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                    <Card
                        sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "18px",
                            overflow: "hidden",
                            boxShadow: 3,
                        }}
                        data-aos="fade-up"
                    >
                        <CardMedia
                            component="img"
                            image="https://i.postimg.cc/9FYjnbN1/smm10-44.png"
                            alt="Mission"
                            sx={{
                                width: "100%",
                                height: "300px",
                                objectFit: "cover",
                            }}
                        />
                    </Card>
                </Grid>
                {/* Text Content */}
                <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                    <Typography
                        variant="h4"
                        data-aos="fade-up"
                        sx={{
                            fontWeight: "bold",
                            marginBottom: 2,
                            color: "black",
                            fontFamily: '"Montserrat", sans-serif',
                        }}
                    >
                        Mission
                    </Typography>
                    <Typography
                        data-aos="fade-up"
                        variant="body1"
                        sx={{ color: "black", lineHeight: 1.8 }}
                    >
                        Our Mission is to consistently increase the value that we provide for the customers so as to improve our relationship with them. To deliver the best of the best in products and services that we offer to all who choose us.
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default VisionMissionSection;
